import { useFeathersClient } from '@strac/react-client-feathers'
import { useEffect } from 'react'
import { useRouter, useSearch } from '@tanstack/react-router'
import debounce from 'lodash/debounce'

/**
 * Listener
 */
const useListener = (
  serviceName: string,
  debounced: boolean = true
): any => {

  const client = useFeathersClient()

  const router = useRouter()
  const search = useSearch({
    strict: false,
  })

  useEffect(() => {
    const defaultListener = (event: any) => {
      router.navigate({ search })
    }

    const debouncedListener = debounce(defaultListener, 1000);

    const listener = debounced ? debouncedListener : defaultListener

    // console.log('adding listeners', serviceName)
    client.service(serviceName).on('created', listener)
    client.service(serviceName).on('patched', listener)
    client.service(serviceName).on('updated', listener)
    client.service(serviceName).on('removed', listener)

    return () => {
      // console.log('removing listeners', serviceName)
      client.service(serviceName).removeListener('created', listener)
      client.service(serviceName).removeListener('patched', listener)
      client.service(serviceName).removeListener('updated', listener)
      client.service(serviceName).removeListener('removed', listener)
    }
  }, [client, router, search, serviceName, debounced])

  return null

}

export default useListener
